const $win = $(window);
const $doc = $(document);

$win.on('load scroll', function(e){
	if( $(this).scrollTop() > 1 ) {
		$('body').addClass('header-sticky');
	} else {
		$('body').removeClass('header-sticky');
	}
});

$('.header .header__trigger').on('click', function(e){
	e.preventDefault();

	$('body').toggleClass('nav-shown');
});

$doc.on('click', '.tweet', function(e){
	window.open( $(this).data('url'),'_blank' );
});

$doc.on('click', '.callout', function(e){
	window.open( $(this).data('url'),'_self' );
});

$doc.on('focus', '.gform_wrapper input, .gform_wrapper textarea', function(e){
	$(this).closest('.gfield').find('.gfield_label').css({color: '#06174f'});
});

$doc.on('focusout', '.gform_wrapper input, .gform_wrapper textarea', function(e){
	$(this).closest('.gfield').find('.gfield_label').css({color: '#69798c'});
});


// WEBPACK FOOTER //
// ./../js/main.js